export default __webpack_public_path__ + "static/media/bloodshroud.eaeb0baa.png";